<input #checkbox [(ngModel)]="value" type="checkbox" [id]="id" (change)="changed()">
<label [for]="id">
  <span class="col-12" style="top:-3px;font-size: 16px; font-weight: normal;" [innerHtml]="textTag"></span>
</label>